// extracted by mini-css-extract-plugin
export default {"backgroundImg":"JP_ProgramCriteria_backgroundImg__MfvKT","contentImage":"JP_ProgramCriteria_contentImage__MZiuH","boxImage":"JP_ProgramCriteria_boxImage__bHhvW"};